export const CANDIDATE_COUNT = 900_000;
export const EMPLOYER_COUNT = 10_000;
